<h2>{{data.user.fullName}}</h2>
<h3>{{data.role.name}}</h3>
<mat-dialog-content>
  <div *ngIf="data.userPictureEnabled" class="row">
    <img *ngIf="data.userPicture" id="actual-photo"
         [src]="data.userPicture"
         alt="User Photo">
    <div *ngIf="!data.userPicture" id="generic-photo" onError="this.src=''"
         [ngStyle]="{'background-image': 'url(/assets/user-picture-default.png)'}">
    </div>
  </div>
  <div>
    <p *ngIf="data.user.department">
      <mat-icon matTooltip="Department">assignment</mat-icon>
      {{data.user.department}}
    </p>
  </div>
  <div>
    <p *ngIf="data.user.email">
      <mat-icon matTooltip="Email">contact_mail</mat-icon>
      <a href="mailto:{{data.user.email}}">{{data.user.email}}</a>
    </p>
  </div>
  <div>
    <p *ngIf="data.user.phone">
      <mat-icon matTooltip="Phone">contact_phone</mat-icon>
      {{data.user.phone}}
    </p>
  </div>
  <div>
    <p *ngIf="data.user.mobile">
      <mat-icon matTooltip="Mobile">contact_phone</mat-icon>
      {{data.user.mobile}}
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button type="button" class="btnNeutral"[mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>
